<template>
    <div class="loginLogPage">
        <headerNotice routerName="登录日志"></headerNotice>
        <!-- 数据列表 -->
        <div class="dataList">
            <h1>数据列表</h1>
            <div class="tableBox" v-loading="loading">
                <el-table class="table" :data="tableData" border style="width: 100%;text-align:center;">
                    <el-table-column align="center" prop="loginTime" label="时间"></el-table-column>
                    <el-table-column align="center" prop="ip" label="IP"></el-table-column>
                    <el-table-column align="center" prop="address" label="地区"></el-table-column>
                    <el-table-column align="center" prop="userAgent" label="浏览器"></el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: false,
            tableData: [],
            totalCount: 0,//总数据条数
            maxResultCount: 10, //默认一页显示的个数,
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        })
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminUser/GetLoginHistory",
                params:params,
                success(res) {
                    self.tableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        rowClass({ row, rowIndex }) {
            return 'rowClass';
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount,
            };
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
//  数据列表
.dataList {
    margin: 0 250px;
    margin-top: 20px;
    border: 1px solid #c5c5c5;
    background: #fff;
    h1 {
        background: #F3F3F3;
        padding: 10px 20px;
    }
    .table {
        border-top: 1px solid #c5c5c5;
        border-bottom: 1px solid #c5c5c5;
    }
    .pagination {
        background: #fff;
    }
}
</style>
<style lang="scss">
.loginLogPage .el-table td,
.loginLogPage .el-table th.is-leaf {
    border-color: #c5c5c5;
}
.loginLogPage .el-table th.is-leaf {
    color: #333;
}
.loginLogPage .el-table::before {
    border-color: #c5c5c5;
}
</style>